import { css, type Theme } from "@emotion/react";

import { dimensions, helpers } from "@styles";

export const checkMark = css`
  margin-bottom: 1rem;
  @media (min-width: ${dimensions.phoneLargeMax}) {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  // START: Needed for legacy pages
  && ul {
    padding-left: 0;
  }
  // END: Needed for legacy pages
`;

export const listItem = css`
  align-items: baseline;
`;

export const listItemLeft = css`
  display: flex;
  align-items: baseline;
  text-align: left;
`;

export const icon = (theme: Theme) => css`
  margin-right: 0.75rem;
  color: ${theme.success.textBase};
`;

export const dropzoneContainer = css`
  cursor: pointer;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const readyContainer = css`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  padding: 0.5rem;
`;

export const noPaddingReadyContainer = css`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const credentialsSvg = css`
  max-height: 4rem;
  margin: 1rem;
`;

export const error = (theme: Theme) => css`
  color: ${theme.danger.textBase};
  margin-top: 1rem;
  text-align: center;
`;

export const zoneText = (theme: Theme) => css`
  padding: 1rem 1.5rem;
  border: 1px dashed ${theme.system.borderBase};
  outline: none;
  width: 100%;
`;

export const zoneTextRounded = (theme: Theme) => css`
  padding: 1rem 1.5rem;
  border: 1px dashed ${theme.system.borderBase};
  border-radius: 4px;
  outline: none;
  width: 100%;
`;

export const dropzoneIsDroppable = (theme: Theme) => css`
  box-shadow: 0 0 0 4px ${helpers.hexToRgba(theme.success.textBase, 0.65)};
`;

export const dropzoneIsDisabled = css`
  opacity: 0.5;
  cursor: default;
`;
